import { render, staticRenderFns } from "./ComboboxMetadataInput.vue?vue&type=template&id=ded9782c"
import script from "./ComboboxMetadataInput.vue?vue&type=script&lang=js"
export * from "./ComboboxMetadataInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports